import { map } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmComponent } from '../confirm.component';
import { IConfirmOptions } from '../interfaces/confirm-options.interface';
import { ConfirmationBoxTypeEnum } from '../enum/confirmation-box-type.enum';
 


@Injectable({
  providedIn: 'root'
})
export class ConfirmService {

  confirmationBoxType !: ConfirmationBoxTypeEnum;
  confirmationBoxResultEnum !: boolean;
  dialogRef !: MatDialogRef<ConfirmComponent>
  private confirmsOptions: any[] = [];
  constructor(public matDialog: MatDialog) { }

  public open(config: IConfirmOptions) {
    this.addOptions({
      ...config
    })
    this.dialogRef = this.matDialog.open(ConfirmComponent,
      {
        enterAnimationDuration: '0ms',          
      }
    )
    return this.dialogRef.afterClosed().pipe(map(() => {
      const result = this.confirmOptions.confirmationBoxResultEnum;
      this.removeOptions()
      return result
    }))
  }

  public danger(config: IConfirmOptions) {
    this.confirmationBoxType = ConfirmationBoxTypeEnum.Danger;
    return this.open(config);
  }

  public info(config: IConfirmOptions) {
    this.confirmationBoxType = ConfirmationBoxTypeEnum.Info;
    return this.open(config);
  }

  public warning(config: IConfirmOptions) {
    this.confirmationBoxType = ConfirmationBoxTypeEnum.Warning;
    return this.open(config);
  }

  public success(config: IConfirmOptions) {
    this.confirmationBoxType = ConfirmationBoxTypeEnum.Info;
    return this.open(config);
  }

  private addOptions(options: any): void {
    this.confirmsOptions = [...this.confirmsOptions, options];
  }

  public get confirmOptions(): any {
    return this.confirmsOptions[this.confirmsOptions.length - 1];
  }

  private removeOptions(): void {
    this.confirmsOptions.length = this.confirmsOptions.length - 1;
  }
}
